export default __webpack_public_path__ + "static/media/nanonets.a9cdf82a.svg";